
export const vRequired = (
  rule,
  val,
  empty,
  trigger,
  skip,
) => {
  if (!rule.required) return null;

  if (empty || !val) {
    if (trigger === "onChange" && skip) return null;
    return rule.message || null;
  }

  return null;
};
